import { assetsClient } from '@/clients/assets-client.js';
import type { AssetType } from '@/clients/assets-client.js';

export type { AssetType };
export type { AssetTypeProperty } from '@/clients/assets-client.js';

class AssetTypesCache {
    private _cache: AssetType[] | null = null;
    private _loading: Promise<AssetType[]> | null = null;

    async getAll(): Promise<AssetType[]> {
        if (this._cache) return this._cache;
        if (!this._loading) {
            this._loading = this._fetchAll().finally(() => { this._loading = null; });
        }
        return this._loading;
    }

    async getByCode(code: string): Promise<AssetType | undefined> {
        const types = await this.getAll();
        return types.find(t => t.code === code);
    }

    invalidate() {
        this._cache = null;
    }

    private async _fetchAll(): Promise<AssetType[]> {
        const results: AssetType[] = [];
        let pageToken: string | null = null;

        do {
            const { assetTypes, nextPageToken } = await assetsClient.listAssetTypes(pageToken);
            results.push(...assetTypes);
            pageToken = nextPageToken;
        } while (pageToken);

        this._cache = results;
        return results;
    }
}

export const assetTypesCache = new AssetTypesCache();